const actions = {
    FETCH_SUBJECTIVE_ATTENDANCE : 'FETCH_SUBJECTIVE_ATTENDANCE',
    FETCH_SUBJECTIVE_ATTENDANCE_REPORTS : 'FETCH_SUBJECTIVE_ATTENDANCE_REPORTS',
    FETCH_SUBJECTIVE_ATTENDANCE_RESET: 'FETCH_SUBJECTIVE_ATTENDANCE_RESET',
    FETCH_SUBJECTIVE_ATTENDANCE_REPORTS_RESET: 'FETCH_SUBJECTIVE_ATTENDANCE_REPORTS_RESET',

    fetchSubjectiveAttendanceAction: (data) => {
        return {
            type: actions.FETCH_SUBJECTIVE_ATTENDANCE,
            data: data
        };
    },
    fetchSubjectiveAttendanceReportsAction: (data) => {
        return {
            type: actions.FETCH_SUBJECTIVE_ATTENDANCE_REPORTS,
            data: data
        };
    },
    resetFetchSubjectiveAttendanceFromAction: (data) => {
        return {
            type: actions.FETCH_SUBJECTIVE_ATTENDANCE_RESET,
            data: data
        };
    },
    resetFetchSubjectiveAttendanceReportsFromAction: (data) => {
        return {
            type: actions.FETCH_SUBJECTIVE_ATTENDANCE_REPORTS_RESET,
            data: data
        };
    },
}

export default actions;
